import {
  renderDocViewLink,
  renderLink,
  renderMailto,
  renderNavigator,
  renderNavigatorWithState,
  renderRoleBasedNavigator,
} from "./grid-cell-renderers";
import {
  formatFileSize,
  formatMeetingProvider,
  toLocalDateTime,
  toLocalDate,
  toUSD,
  caseUserSide,
  formatQuestionOptions,
  formatQuestionOptionType,
  caseUserPrimary,
  capitalizeFirst,
} from "./grid-value-formatters";

export const meetingsTable = [
  { headerName: "Title", field: "title" },
  { headerName: "Start Time", field: "start", valueFormatter: toLocalDateTime },
  { headerName: "Join URL", field: "link", cellRenderer: renderLink },
  {
    headerName: "Provider",
    field: "type",
    valueFormatter: formatMeetingProvider,
  },
];
export const zoomMeetingsTable = [
  { headerName: "Title", field: "topic" },
  {
    headerName: "Start Time",
    field: "start_time",
    valueFormatter: toLocalDateTime,
  },
  { headerName: "Join URL", field: "join_url", cellRenderer: renderLink },
  // {
  //   headerName: "Provider",
  //   field: "type",
  //   valueFormatter: formatMeetingProvider,
  // },
];
export const caseDocsTable = [
  // { headerName: "Filename", field: "name", cellRenderer: renderDocViewLink },
  { headerName: "Size", field: "size", valueFormatter: formatFileSize },
  { headerName: "Description", field: "text" },
  { headerName: "Uploader", field: "uploader_name" },
  {
    headerName: "Created At",
    field: "created_at",
    valueFormatter: toLocalDate,
  },
];

export const casesTable = [
  {
    headerName: "Title",
    field: "title",
    minWidth: 210,
    cellRenderer: (params) =>
      renderRoleBasedNavigator(params, [
        "ADMIN",
        "USER",
        "REGISTRAR",
        "TRIAL_USER",
      ]),
  },
  // { headerName: "Description", field: "description" },
  {
    headerName: "Start Date",
    field: "start_date",
    valueFormatter: toLocalDate,
  },
  { headerName: "End Date", field: "end_date", valueFormatter: toLocalDate },
  { headerName: "Status", field: "status" },
  { headerName: "Type", field: "type" },
  {
    headerName: "Created At",
    field: "created_at",
    valueFormatter: toLocalDate,
  },
  { headerName: "Created By", field: "creator_name" },
];

export const caseUsersTable = [
  { headerName: "Name", field: "user_name" },
  { headerName: "Type", field: "type" },
  { headerName: "Email", field: "user_email" },
  { headerName: "Side", field: "from_plaintiff", valueFormatter: caseUserSide },
  {
    headerName: "Primary User",
    field: "is_primary",

    valueFormatter: caseUserPrimary,
  },
];

export const caseNegotiationsTable = [
  {
    headerName: "Title",
    field: "title",
    cellRenderer: renderNavigator,
    minWidth: 100,
  },
  {
    headerName: "Description",
    field: "description",
    minWidth: 120,
    tooltipField: "description",
  },
  {
    headerName: "Start Amount($)",
    field: "start_amount",
    valueFormatter: toUSD,
    minWidth: 160,
  },
  {
    headerName: "Latest Amount($)",
    field: "latest_amount",
    valueFormatter: toUSD,
    minWidth: 160,
  },
  { headerName: "Status", field: "status", minWidth: 100 },
  {
    headerName: "Last Updated",
    field: "updated_at",
    valueFormatter: toLocalDateTime,
    minWidth: 200,
  },
  { headerName: "Initiator", field: "creator_name", minWidth: 100 },
];

export const usersTable = [
  {
    headerName: "First Name",
    field: "firstname",
    minWidth: 150,

    cellRenderer: renderNavigatorWithState,
  },
  { headerName: "Last Name", field: "lastname", minWidth: 150 },
  {
    headerName: "Email",
    field: "email",
    cellRenderer: renderMailto,
    minWidth: 250,
    tooltipField: "email",
  },
  { headerName: "Phone", field: "phone", minWidth: 150 },
  { headerName: "Role", field: "role", minWidth: 120 },
  {
    headerName: "Last Accessed Date",
    field: "last_accessed_date",
    valueFormatter: toLocalDate,
    minWidth: 180,
  },
  // { headerName: "Address", field: 'address' },
  // { headerName: "Address Line 2", field: 'address2' },
  // { headerName: "City", field: 'city' },
  // { headerName: "State", field: 'state' },
  // { headerName: "Zipcode", field: 'zipcode' },
  // { headerName: "Country", field: 'country' },
];

export const questionsTable = [
  {
    headerName: "Case Type",
    field: "case_type",
    cellRenderer: renderNavigatorWithState,
  },
  {
    headerName: "Question",
    field: "question",
  },
  {
    headerName: "Options",
    field: "options",
    minWidth: 300,
    valueFormatter: formatQuestionOptions,
  },
  {
    headerName: "Multiple Options",
    field: "multiple",
    valueFormatter: formatQuestionOptionType,
  },
];

export const customerTable = [
  {
    headerName: "First Name",
    field: "firstname",
    minWidth: 120,
    cellRenderer: renderNavigatorWithState,
  },
  { headerName: "Last Name", field: "lastname", minWidth: 120 },

  { headerName: "Email", field: "email", minWidth: 200 },
  // { headerName: "Password", field: "password"},
  { headerName: "Phone", field: "phone", minWidth: 130 },

  { headerName: "Address", field: "address", minWidth: 120 },
  { headerName: "Address2", field: "address2", minWidth: 120 },
  { headerName: "City", field: "city", minWidth: 100 },
  { headerName: "State", field: "state", minWidth: 100 },
  { headerName: "Country", field: "country", minWidth: 100 },
  { headerName: "Zip", field: "zipcode", minWidth: 100 },
  // { headerName: "Zip", field: ""},
  // { headerName: "Start Date", field: "start_date", valueFormatter: toLocalDate },
  // { headerName: "End Date", field: "end_date", valueFormatter: toLocalDate },
  // { headerName: "Status", field: "status" },
  // { headerName: "Type", field: "type" },
  // { headerName: "Created At", field: "created_at", valueFormatter: toLocalDate },
  // { headerName: "Created By", field: "creator_name" }
];

export const submittedQuesAnsTable = [
  {
    headerName: "Case Type",
    field: "case_type",
    cellRenderer: renderNavigatorWithState,
  },

  {
    headerName: "Email",
    field: "email",
  },
  {
    headerName: "First Name",
    field: "firstname",
  },
  {
    headerName: "Status",
    field: "status",
    cellRenderer: capitalizeFirst,
  },
];
export const submittedQuesAnsDetailTable = [
  {
    headerName: "Question",
    field: "question",
  },

  {
    headerName: "Multiple",
    field: "multiple",
  },
  {
    headerName: "Options",
    field: "options",
    valueFormatter: formatQuestionOptions,
  },
  {
    headerName: "Answer",
    field: "answer",
  },
];
